module.exports = __webpack_public_path__ + "img/marker_start.a859da3d.svg";